// settings/HamburgerMenu/sections/KnowledgeSection.tsx
import React from "react";
import DifyKnowledgeSection from "./DifyKnowledgeSection";
import AwsKnowledgeSection from "./AwsKnowledgeSection";

const isAWS = process.env.REACT_APP_SYSTEM_REQUIREMENT === "aws";

/**
 * ナレッジセクション
 * REACT_APP_SYSTEM_REQUIREMENT=awsの場合はBedrock/S3経由のAWS版を使用
 * それ以外はDify版を使用
 */
const KnowledgeSection: React.FC = () => {
  if (isAWS) {
    return <AwsKnowledgeSection />;
  }
  return <DifyKnowledgeSection />;
};

export default KnowledgeSection;
